const config = {
  mdsimWebUrl: "https://mdsim.net/",
  oauthServerUrl: process.env.REACT_APP_IDENTITY_SERVER_URL,
  clientId: "spinesim-front-1",
  scope: "spinesim",
  validateUserPath: "/User/validate",
};

export default config; 
